import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BodyParent, BodyChildren } from './animation/variants';

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: 'column !important',
    marginTop: '-50px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '375px',
      width: '100%',
      marginTop: '0px',
    },
    [theme.breakpoints.up('md')]: {
      width: '500px',
    },
    [theme.breakpoints.up('xl')]: {
      width: '650px',
    },
  },
  windowWrapper: {
    boxShadow: '0px 1px 14px -1px rgba(0,0,0,0.25)',
  },
  topBar: {
    width: '100%',
    height: '30px',
    background: '#394F94',
    borderRadius: '8px 8px 0px 0px',
  },
  windowButtons: {
    margin: '10px 20px',
  },
  body: {
    background: '#FFFFFF',
    padding: '30px',
    borderRadius: '0px 0px 8px 8px',
  },
  title: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
  },
  description: {
    maxWidth: '950px',
    fontSize: 24,
    fontWeight: 'normal',
    lineHeight: '31px',
    textAlign: 'center',
    letterSpacing: '-0.03em',
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  ipadWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ipad: {
    width: '308px',
    height: '318px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-120px',
      marginRight: '30px',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '-120px',
      marginRight: '-160px',
    },
  },
}));

const Wrapper = styled.div`
  display: flex;
`;

const TopBar = styled.div``;

const Body = styled.div``;

const CovidInfoBox = () => {
  const [ref, inView] = useInView({
    rootMargin: '0px 100px',
    triggerOnce: true,
  });

  const classes = useStyles();

  return (
    <motion.div
      className={classes.root}
      ref={ref}
      variants={BodyParent}
      initial="initial"
      animate={inView ? 'enter' : 'initial'}>
      <Wrapper className={classes.root}>
        <div className={classes.windowWrapper}>
          <TopBar className={classes.topBar}>
            <img
              src={require('./assets/window-buttons.png')}
              alt="window-buttons"
              className={classes.windowButtons}
            />
          </TopBar>
          <Body className={classes.body}>
            <motion.div variants={BodyChildren}>
              <Typography variant="h2" className={classes.title}>
                That's A Wrap!
              </Typography>
            </motion.div>
            <motion.p variants={BodyChildren} className={classes.description}>
              Thank you all for attending Hack Western's first virtual
              hackathon. With 600+ attendees this year, we're excited to bring
              you something new next year. Keep an eye out for new
              announcements!
            </motion.p>
          </Body>
        </div>
        <div className={classes.ipadWrapper}>
          <motion.img
            variants={BodyChildren}
            src={require('./assets/ipad.png')}
            alt="ipad"
            className={classes.ipad}
          />
        </div>
      </Wrapper>
    </motion.div>
  );
};

export default CovidInfoBox;
